import { disabledColor } from '../global';

const settingShoppingCartStyle = () => (
    {
        item: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'baseline',
        },
        itemCart: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        leftTitle: {
            width: '25%',
            textAlign: 'left',
            paddingRight: '46px',
        },
        rightInput: {
            width: '74%',
            marginBottom: '15px',
        },
        rightInputDisable: {
            width: '74%',
            marginBottom: '15px',
            pointerEvents: 'none',
        },
        checkBox: {
            '& span': {
                fontSize: '14px',
            },
        },
        room: {
            padding: '20px 20px 20px 0',
            marginBottom: '50px',
        },
        disabled: {
            padding: '20px 20px 20px 0',
            marginBottom: '50px',
            backgroundColor: disabledColor,
        },
        right: {
            margin: '0 0 15px 0',
        },
        buttonSubmit: {
            textAlign: 'center',
            zIndex: 1,
        },
    }
);

export default settingShoppingCartStyle;
